export const API_URL = process.env.REACT_APP_API_URL;
export const STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY;
export const APPLE_KEY = process.env.REACT_APP_APPLE_KEY;
export const FACEBOOK_KEY = process.env.REACT_APP_FACEBOOK_KEY;
export const GOOGLE_KEY = process.env.REACT_APP_GOOGLE_KEY;
